import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";

const title = 'Jak to działa?'
type listItem = {
    step: string,
    description: string,
}
const list: listItem[] = [
    {
        step: "01",
        description: "Wypełnij formularz",
    },
    {
        step: "02",
        description: "Złóż zapytanie ofertowe",
    },
    {
        step: "03",
        description: "Potwierdź ofertę lub poczekaj na telefon od konsultanta",
    }

]

export const HowItWorks = () => {
    return (
        <>
            {/* <Title>{title}</Title> */}
            {list.map((item) => (
                <ItemWraper key={item.step} >
                    <ItemNumber>
                        <Circle>{item.step}</Circle>
                    </ItemNumber>
                    <ItemDescription>{item.description}</ItemDescription>
                </ItemWraper>
            ))}
        </>
    );
};

const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
padding-bottom:23px;
`;
const ItemWraper = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
display:flex;
flex-direction:row;
justify-content: flex-start;
padding-bottom:16px;
`;
const ItemNumber = styled.div`
font-family: ${theme.fonts.interRegular}
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
text-align: center;
color: ${theme.colors.gray04_background};

`;
const Circle = styled.div`
padding: 6px 8px;
background-color: ${theme.colors.black_primaryText};
border-radius: 32px;
`;

const ItemDescription = styled.div`
padding-left:12px;
font-family: ${theme.fonts.interRegular}
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
`;